import _defineProperty from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import classNames from 'classnames';
import * as React from 'react';
import LoadingOutlined from "@ant-design/icons/es/icons/LoadingOutlined";
import TimelineItem from './TimelineItem';

var TimelineItemList = function TimelineItemList(_a) {
  var _classNames;

  var prefixCls = _a.prefixCls,
      className = _a.className,
      _a$pending = _a.pending,
      pending = _a$pending === void 0 ? false : _a$pending,
      children = _a.children,
      items = _a.items,
      rootClassName = _a.rootClassName,
      _a$reverse = _a.reverse,
      reverse = _a$reverse === void 0 ? false : _a$reverse,
      direction = _a.direction,
      hashId = _a.hashId,
      pendingDot = _a.pendingDot,
      _a$mode = _a.mode,
      mode = _a$mode === void 0 ? '' : _a$mode,
      restProps = __rest(_a, ["prefixCls", "className", "pending", "children", "items", "rootClassName", "reverse", "direction", "hashId", "pendingDot", "mode"]);

  var getPositionCls = function getPositionCls(position, idx) {
    if (mode === 'alternate') {
      if (position === 'right') return "".concat(prefixCls, "-item-right");
      if (position === 'left') return "".concat(prefixCls, "-item-left");
      return idx % 2 === 0 ? "".concat(prefixCls, "-item-left") : "".concat(prefixCls, "-item-right");
    }

    if (mode === 'left') return "".concat(prefixCls, "-item-left");
    if (mode === 'right') return "".concat(prefixCls, "-item-right");
    if (position === 'right') return "".concat(prefixCls, "-item-right");
    return '';
  };

  var mergedItems = _toConsumableArray(items || []);

  var pendingNode = typeof pending === 'boolean' ? null : pending;

  if (pending) {
    mergedItems.push({
      pending: !!pending,
      dot: pendingDot || /*#__PURE__*/React.createElement(LoadingOutlined, null),
      children: pendingNode
    });
  }

  if (reverse) {
    mergedItems.reverse();
  }

  var itemsCount = mergedItems.length;
  var lastCls = "".concat(prefixCls, "-item-last");
  var itemsList = mergedItems.filter(function (item) {
    return !!item;
  }).map(function (item, idx) {
    var _a;

    var pendingClass = idx === itemsCount - 2 ? lastCls : '';
    var readyClass = idx === itemsCount - 1 ? lastCls : '';

    var itemClassName = item.className,
        itemProps = __rest(item, ["className"]);

    return /*#__PURE__*/React.createElement(TimelineItem, Object.assign({}, itemProps, {
      className: classNames([itemClassName, !reverse && !!pending ? pendingClass : readyClass, getPositionCls((_a = item === null || item === void 0 ? void 0 : item.position) !== null && _a !== void 0 ? _a : '', idx)]),

      /* eslint-disable-next-line react/no-array-index-key */
      key: (item === null || item === void 0 ? void 0 : item.key) || idx
    }));
  });
  var hasLabelItem = mergedItems.some(function (item) {
    return !!(item === null || item === void 0 ? void 0 : item.label);
  });
  var classString = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-pending"), !!pending), _defineProperty(_classNames, "".concat(prefixCls, "-reverse"), !!reverse), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(mode), !!mode && !hasLabelItem), _defineProperty(_classNames, "".concat(prefixCls, "-label"), hasLabelItem), _defineProperty(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className, rootClassName, hashId);
  return /*#__PURE__*/React.createElement("ul", Object.assign({}, restProps, {
    className: classString
  }), itemsList);
};

export default TimelineItemList;